import React from "react";
import { Col, Row } from "reactstrap";
import { CheckCircle, Clock } from "react-feather";
import { useWizard } from "react-use-wizard";
import PrimaryButton from "../../../../../../../../toolkit/primaryButton";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import WizardFormStep from "../../../../components/WizardFormStep";

interface DnsAuthorizationCompleteProps {
  domain: string;
  onContinue: () => void;
}

const DnsAuthorizationComplete: React.FC<DnsAuthorizationCompleteProps> = ({
  domain,
  onContinue,
}) => {
  const { nextStep } = useWizard();
  
  return (
    <WizardFormStep
      title="DNS Authorization Complete"
      subtitle="Your DNS records have been successfully configured"
    >
      <Row className="justify-content-center">
        <Col md="9">
          <div className={s.authorizationContainer}>
            <div className={s.authorizationContent}>
              <div className={s.statusList}>
                <div className={s.statusItem}>
                  <CheckCircle size={20} className={s.checkIcon} />
                  <span className={s.statusText}>DNS records have been submitted to your provider</span>
                </div>
                <div className={s.statusItem}>
                  <Clock size={20} className={s.clockIcon} />
                  <span className={s.statusText}>DNS changes are propagating (typically 15-30 minutes)</span>
                </div>
              </div>

              <div className={s.infoMessage}>
                <p className={s.infoDescription}>
                  Your domain <strong>{domain}</strong> configuration will be active soon.
                  We'll verify it automatically in the background.
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mt-4 justify-content-center mb-5">
        <Col md="4" className="text-center">
          <PrimaryButton
            variant="primary"
            onClick={nextStep}
          >
            Continue
          </PrimaryButton>
        </Col>
      </Row>
    </WizardFormStep>
  );
};

export default withStyles(s)(DnsAuthorizationComplete);
